module.exports = "/images/banner-01.jpg?d6fb0c3fe4e942be286e10f873664a7d";